import {
  Box,
  Typography,
  Button,
  Grid,
  TextField,
  FormControl,
  Select,
  MenuItem,
  IconButton,
  FormLabel,
  Autocomplete,
} from "@mui/material";
import {
  Delete as DeleteIcon,
  CloudUpload as UploadIcon,
} from "@mui/icons-material";
import AutocompleteWithPagination from "../autocomplete-with-pagination";
import buildQuery from "../../utils/query-builder";
import { productService } from "../../services/product-service";
import { useEffect, useState } from "react";

const labelStyle = {
  mb: 1,
  fontSize: "0.875rem",
  fontFamily: "Poppins",
};

const ProductRow = ({
  product,
  index,
  onUpdate,
  onRemove,
  errors,
  mockProducts,
  handleAttachmentChange,
  clientId,
}) => {
  const handleChange = (field, value) => {
    onUpdate(index, { ...product, [field]: value });
  };

  const [selectedProduct, setSelectedProduct] = useState(
    product.product || null
  );
  useEffect(() => {
    if (product.product) {
      setSelectedProduct(product.product);
    }
  }, [product, selectedProduct]);

  return (
    <Box
      sx={{
        p: 2,
        mb: 2,
        bgcolor: "#F6F6F6",
        borderRadius: 1,
        fontFamily: "Poppins",
        textAlign: "left",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 2,
        }}
      >
        <Typography variant="subtitle2" sx={{ fontFamily: "Poppins" }}>
          Product {index + 1}
        </Typography>
        <IconButton onClick={() => onRemove(index)} color="error" size="small">
          <DeleteIcon />
        </IconButton>
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={12} md={3}>
          <FormLabel sx={labelStyle} required>
            Select Product
          </FormLabel>
          <AutocompleteWithPagination
            disabled={!clientId}
            selectedClient={clientId}
            hideLabel
            backgroundColor="#FFF"
            selectedItem={product.product}
            customLabel={"Product"}
            onDataChange={(product) => {
              if (product == null) {
                console.log("Product cleared");
                setSelectedProduct(null); // clear variants list
                handleChange("product", null); // clear product
                handleChange("sku", null); // clear SKU
              } else {
                handleChange("product", product);
                setSelectedProduct(product);
              }
            }}
            width="100%"
            optionKey="name"
            apiEndPoint={(limit, skip, search, client) => {
              const query = buildQuery({ limit, skip });
              return productService.fetch(client, search, query);
            }}
            errorMessage={errors.product}
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <FormLabel sx={labelStyle} required>
            Variant
          </FormLabel>
          <Autocomplete
            options={
              Array.isArray(selectedProduct?.variants)
                ? selectedProduct.variants
                : []
            }
            getOptionLabel={(option) => option?.sku || ""}
            value={product.sku || null}
            onChange={(_, selectedVariant) => {
              handleChange("sku", selectedVariant);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                size="small"
                required
                error={!!errors.sku}
                helperText={errors.sku || ""}
                fullWidth
                sx={{ backgroundColor: "#fff" }}
              />
            )}
            sx={{ mt: 1 }}
            isOptionEqualToValue={(option, value) => option._id === value?._id}
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <FormLabel sx={labelStyle} required>
            Quantity
          </FormLabel>
          <TextField
            style={{
              marginTop: 8,
              backgroundColor: "#FFF",
              fontFamily: "Poppins",
            }}
            fullWidth
            size="small"
            type="number"
            value={product.quantity_requested || ""}
            onChange={(e) => handleChange("quantity_requested", e.target.value)}
            error={!!errors.quantity_requested}
            helperText={errors.quantity_requested}
            inputProps={{ min: 1, step: 1 }}
          />
        </Grid>
        {/* <Grid item xs={12} md={2}>
            <FormLabel sx={labelStyle} required>
              Price
            </FormLabel>
            <TextField
              style={{
                marginTop: 8,
                backgroundColor: "#FFF",
                fontFamily: "Poppins",
              }}
              fullWidth
              size="small"
              type="number"
              value={product.price || ""}
              onChange={(e) => handleChange("price", e.target.value)}
              error={!!errors.price}
              helperText={errors.price}
            />
          </Grid> */}
        <Grid item xs={12} md={4}>
          <FormLabel sx={labelStyle}>Upload A Attachment</FormLabel>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Button
              style={{
                marginTop: 8,
                backgroundColor: "#FFF",
                minHeight: 38,
                fontFamily: "Poppins",
                fontSize: 8,
              }}
              variant="outlined"
              component="label"
              startIcon={<UploadIcon />}
              size="small"
            >
              Choose File
              <input
                type="file"
                accept="*/*"
                hidden
                onChange={(e) => handleAttachmentChange(e, index)}
              />
            </Button>
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ fontFamily: "Poppins" }}
            >
              {product.attachment
                ? product.attachment.fileName
                : "No File Chosen"}
            </Typography>
          </Box>
          {/* {product.attachment && (
              <Box sx={{ mt: 1 }}>
                {isImage ? (
                  <img
                    src={product.attachmentUrl}
                    alt={product.attachment.fileName}
                    style={{ width: 100, height: 100, objectFit: "cover" }}
                  />
                ) : (
                  <Typography variant="body2">
                    {product.attachment.fileName}
                  </Typography>
                )}
              </Box>
            )} */}
        </Grid>
        <Grid item xs={12}>
          <FormLabel sx={labelStyle}>Instructions</FormLabel>
          <TextField
            style={{
              backgroundColor: "#FFF",
              fontFamily: "Poppins",
              marginTop: 8,
            }}
            fullWidth
            size="small"
            multiline
            value={product.instructions || ""}
            onChange={(e) => handleChange("instructions", e.target.value)}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ProductRow;
